import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog'
import { Button } from '../../ui/button'
import { ScrollArea } from '../../ui/scroll-area'
import { Copy } from 'lucide-react'
import toast from 'react-hot-toast'
import { DetailedBlockchainTxnResponse } from '../../../lib/api/blockchainTransactionService'

interface RawJsonModalProps {
  transaction: DetailedBlockchainTxnResponse
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const RawJsonModal: React.FC<RawJsonModalProps> = ({ transaction, open, onOpenChange }) => {
  const copyFullJson = () => {
    navigator.clipboard.writeText(JSON.stringify(transaction, null, 2))
      .then(() => toast.success('Full transaction JSON copied to clipboard'))
      .catch(() => toast.error('Failed to copy to clipboard'))
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle>Raw Transaction JSON</DialogTitle>
            <Button variant="outline" size="sm" onClick={copyFullJson}>
              <Copy className="h-4 w-4 mr-2" />
              Copy All
            </Button>
          </div>
          <DialogDescription>
            Complete transaction object including all metadata and data fields
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] w-full rounded-md border">
          <pre className="p-4 text-sm overflow-auto whitespace-pre-wrap font-mono">
            {JSON.stringify(transaction, null, 2)}
          </pre>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
